import { lazy } from "react";
import { Navigate, Outlet } from "react-router";

import docgenRoutes from "./docgen/docgenRoutes";
import emailgenRoutes from "./emailgen/emailgenRoutes";
import fvToolsRoutes from "./fv-tools/fvToolsRoutes";
import AccessValidation from "./portal/components/AccessValidation";
import HubNavigate from "../common/components/HubNavigate";
import { element } from "prop-types";

const Medchart = lazy(() => import("./medchart/components/Medchart"));
const SettlementCalc = lazy(
  () => import("./settlement-calculator/pi-settlement-calculator/components/SettlementCalculator"),
);
const LegacySettlementCalc = lazy(
  () => import("./settlement-calculator/pi-settlement-calculator-legacy/components/LegacySettlementCalculator"),
);
const EmpSettlementCalc = lazy(
  () => import("./settlement-calculator/emp-settlement-calculator/components/EmploymentSettlementCalculator"),
);
const ConflictCheck = lazy(() => import("./conflictcheck/components/ConflictCheck"));
const ItemDeletionWidget = lazy(() => import("./collection-item-deletion/components/ItemDeletionWidget"));
const ProposalManager = lazy(() => import("./proposal-manager/components/ProposalManager"));
const NetSuiteReports = lazy(() => import("./netsuite-reports/components/NetSuiteReports"));
const RecordsOrdering = lazy(() => import("./records-ordering/components/RecordsOrdering"));
const FVPhaseChange = lazy(() => import("./fv-phase-change/FVPhaseChange"));

const widgetRoutes = [
  { index: true, element: <Navigate to={process.env.PUBLIC_URL} /> },
  { path: "docgen", element: <Outlet />, children: docgenRoutes },
  { path: "fv-tools", element: <Outlet />, children: fvToolsRoutes },
  { path: "medchart/:projectId", element: <Medchart /> },
  { path: "settlement-calculator/:projectId/pi", element: <SettlementCalc /> },
  { path: "legacy-settlement-calculator/:projectId", element: <LegacySettlementCalc /> },
  { path: "settlement-calculator/:projectId/emp", element: <EmpSettlementCalc /> },
  { path: "conflict-check/:leadId?", element: <ConflictCheck /> },
  { path: "portal/access-validation/:projectId", element: <AccessValidation /> },
  {
    path: "collection-item-deletion/:projectId",
    element: <Outlet />,
    children: [
      { index: true, element: <ItemDeletionWidget /> },
      { path: ":sectionSelector", element: <ItemDeletionWidget /> },
    ],
  },
  { path: "emailgen/:projectId", element: <Outlet />, children: emailgenRoutes },
  { path: "netsuite-reports/:projectId", element: <NetSuiteReports /> },
  { path: "proposal-manager/:projectId", element: <ProposalManager /> },
  {
    path: "fv-phase-change/:projectId",
    children: [{ path: "*", element: <FVPhaseChange /> }],
  },

  {
    path: "records-ordering/:projectId",
    element: <Outlet />,
    children: [
      { index: true, element: <HubNavigate to={`contacts`} /> },
      { path: ":viewSelector", element: <RecordsOrdering /> },
    ],
  },
];

export default widgetRoutes;
